import { Button } from 'antd'
import DrawerBox from '../../../components/common/DrawerBox'
import { isMobile } from 'react-device-detect'
import { AiOutlineClose } from 'react-icons/ai'
import { DefaultProfileIcon } from '../../../utilities/resources'

function UserConferenceSummary({ open, setOpen, userClosestMatch, finalSummaryText }) {
  console.log('userClosestMatch', userClosestMatch)
  return (
    <DrawerBox placement={isMobile ? 'bottom' : 'right'} headerStyle={{ display: 'none' }} bodyStyle={{ padding: '16px' }} height={'90vh'} visible={open} setVisible={setOpen}>
      <div className='flex fd-row items-center jc-space-between'>
        <h3 className='font-size-20 font-bold-700 font-color-2'>Overview</h3>
        <Button type='link' size='medium' danger ghost onClick={setOpen} className='flex fd-row items-center font-size-16'>
          <AiOutlineClose className='mr-4' />
          Close
        </Button>
      </div>
      <div className='text-center mt-24'>
        <h2 className='font-size-42 font-bold-700 font-color-pink kaushan-script-font'>Congratulations</h2>
        <p className='font-size-20 font-color-green font-bold-500 mt-8'>{finalSummaryText ? finalSummaryText : `You've been an engaged and valuable contributor during the conference`}</p>
        {userClosestMatch?.length > 0 ? <p className='font-size-16 font-color-1 mt-8'>Your responses closely match those of the users below</p> : ''}
      </div>
      <div className='grid grid-one gap-16 mt-32'>
        {userClosestMatch?.length > 0 &&
          userClosestMatch.map((items) => {
            return (
              <div key={items.userId} className='flex fd-column items-center rounded-12 o-hidden' style={{ outline: '3px solid rgba(237,62,114,0.5)' }}>
                <div className='bg-5 height-fit-content width-full flex-shrink-0 o-hidden' style={{ borderRadius: '12px 12px 0px 0px' }}>
                  <img src={items.profilePic || DefaultProfileIcon} alt={items.name} className='width-full height-full obj-fit-fill' />
                </div>
                <div className='p-8 width-full o-hidden' style={{ background: 'rgba(255,132,168,0.5)' }}>
                  <h3 className='font-size-18 font-bold-700 font-color-1 text-center'>{items.name}</h3>
                </div>
              </div>
            )
          })}
      </div>
    </DrawerBox>
  )
}

export default UserConferenceSummary
